
const initialState = {
	services: [],
	servicesArray: [],
	products: null,
	product: null,
}

// REDUCERS
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'loadServices@services': {
			return {
				...state,
				services: action.data
			}
		}

		default: return state
	}
}
